import React, { Component } from 'react';
import './Job.css'
import check from '../../../Assets/img/check.png'
import axios from 'axios'
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import {Link} from 'react-router-dom'


export default class JobPaySuccess extends Component { 

    constructor() {
        super();
        this.state={
        loader:false,   
        user:[],
        id:'',
        }

    }


    

    componentDidMount(){
        this.getUser()
    }

getUser() {
        axios.get(`https://arianaapp.arianaapply.com/api/V1/get-user/${localStorage.getItem('token')}`)
            .then((response) => {
                console.log('user' , response)
                this.setState({user: response.data},() =>{
                    this.payCheck()
                });
                
            });
}

payCheck(){
    axios.post(`https://arianaapp.arianaapply.com/api/V1/check-payment-for-apply` , {
        user_id:this.state.user._id
    }).then(res=>{
        console.log('After Payment Check' , res);
        this.setState({id:res.data.data} , ()=>{
            console.log('post_id' , this.state.id)
        })

    }).catch(err=>{
        console.log(err)
    })
}




    render() {
        return (
            <div className="pay-success">


                   <div className="pay-box-success">
                   <img src={check} alt="check"/>
                   <p>پرداخت شما با موفقیت انجام شد جهت بازگشت به صفحه قبل روی دکمه زیر کلیک کنید</p>
                  
                   

                   {
                this.state.loader === false ?
                <Link to={`single-job/${this.state.id}`}>
                   <button  className="pay-btn-success" >بازگشت </button>
                   </Link>:<Loader
                type="TailSpin"
                color="white"
                height={30}
                width={30}
              />
                  
            }
                   </div>
                   
                  
               </div>
               
        )
    }
 }